import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight, Building2, CheckCircle2 } from 'lucide-react';
const projects = [{
  name: 'Malaga warehouse',
  size: '12,000 sqm',
  detail: '4 weekends, zero business interruption'
}, {
  name: 'Subiaco retail fit out',
  size: '3 stores',
  detail: '6 zones each, same day commissioning'
}, {
  name: 'Joondalup medical practice',
  size: '850 sqm',
  detail: '6 consult rooms, separate clinical zones'
}];
const points = ['Design and install A$5,000 to A$80,000+ range', 'After hours scheduling to protect trading', 'iZone smart zoning for offices and fit outs', 'Full insurance and scope of works documentation'];
export function Commercial() {
  return <section className="bg-white py-20 md:py-28" data-id="element-60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-61">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start" data-id="element-62">
          {/* Content */}
          <div className="lg:col-span-6" data-id="element-63">
            <div className="text-xs font-semibold uppercase tracking-widest text-brand mb-4" data-id="element-64">
              Commercial HVAC
            </div>
            <h2 className="text-2xl md:text-4xl font-bold tracking-tight text-ink leading-tight mb-6" data-id="element-65">
              For Perth offices, retail, warehouses and trades.
            </h2>
            <p className="text-lg text-stone-600 leading-relaxed mb-8 max-w-xl" data-id="element-66">
              Commercial buyers have different priorities: fit for purpose
              design, minimal trading interruption, proper documentation. We
              design and supply install HVAC for Perth businesses, sized
              correctly the first time.
            </p>

            <div className="space-y-3 mb-9" data-id="element-67">
              {points.map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: i * 0.05
            }} className="flex items-center gap-3" data-id="element-68">
                  <CheckCircle2 size={18} className="text-success flex-shrink-0" data-id="element-69" />
                  <span className="text-base text-ink font-medium" data-id="element-70">{item}</span>
                </motion.div>)}
            </div>

            <a href="/commercial-air-conditioning-installation-in-perth/" className="inline-flex items-center gap-2 h-14 px-8 rounded-xl bg-accent hover:bg-accent-600 text-ink text-base font-bold transition-all hover:scale-[1.02] shadow-lg shadow-accent/20" data-id="element-71">
              Get a commercial quote
              <ArrowUpRight size={16} strokeWidth={2.5} data-id="element-72" />
            </a>
          </div>

          {/* Recent projects card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-6" data-id="element-73">
            <div className="bg-brand text-white rounded-2xl p-7 lg:p-9 shadow-xl" data-id="element-74">
              <div className="flex items-center gap-3 mb-7" data-id="element-75">
                <div className="w-10 h-10 rounded-lg bg-accent text-ink flex items-center justify-center" data-id="element-76">
                  <Building2 size={18} data-id="element-77" />
                </div>
                <div className="text-xs uppercase tracking-widest text-white/70 font-semibold" data-id="element-78">
                  Recent commercial installs
                </div>
              </div>

              <div className="space-y-5" data-id="element-79">
                {projects.map((project, i) => <div key={i} className="pb-5 border-b border-white/15 last:border-0 last:pb-0" data-id="element-80">
                    <div className="flex items-baseline justify-between mb-1.5 gap-3" data-id="element-81">
                      <div className="text-lg font-bold tracking-tight" data-id="element-82">
                        {project.name}
                      </div>
                      <div className="text-xs uppercase tracking-wider text-white/70 font-semibold tabular-nums whitespace-nowrap" data-id="element-83">
                        {project.size}
                      </div>
                    </div>
                    <div className="text-sm text-white/80" data-id="element-84">
                      {project.detail}
                    </div>
                  </div>)}
              </div>

              <div className="mt-7 pt-7 border-t border-white/15 flex items-center justify-between gap-4" data-id="element-85">
                <div data-id="element-86">
                  <div className="text-3xl font-extrabold tracking-tight tabular-nums" data-id="element-87">
                    A$5K to A$80K
                  </div>
                  <div className="text-[11px] uppercase tracking-wider text-white/70 mt-1" data-id="element-88">
                    Typical project range
                  </div>
                </div>
                <a href="tel:+61864043888" className="text-sm font-bold text-accent hover:underline underline-offset-2 whitespace-nowrap" data-id="element-89">
                  Talk to Mike →
                </a>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}